<template>
	<!--发布-->
	<el-form ref="form" :model="form" size="small" :rules="rules">
	<section class="publish-main">
		<title-area title="发布时间" :dashed="false">
		 <el-form-item prop="publishType">
			<el-radio-group v-model="form.publishType" @change="openSub()" :disabled="hidsubv">
		    <el-radio :label="1" >审核后立即发布</el-radio>
		    <el-radio :label="2" >定时发布</el-radio>
		    <el-radio :label="3">审核后手动确认发布</el-radio>
		  </el-radio-group>
	    <div id="issue_date_box" class="time_option_box" v-if="form.publishType === 2" >
				<el-date-picker v-model="form.publishTime" type="datetime" placeholder="选择日期时间" :disabled="hidsubv">
				</el-date-picker>
			</div>
		 </el-form-item>
		</title-area>

		<title-area title="授权类型">
		 <el-form-item prop="authType">
		  <el-radio-group v-model="form.authType" @change="authorizationBoxShow()">
		    <el-radio :label="1" >公开发布</el-radio>
		    <el-radio :label="2" >隐私发布</el-radio>
		  </el-radio-group>
         </el-form-item>
		</title-area>
	</section>
	<section id="radio_authorization_form_box" class="form_box text-center" v-if="form.authType === 2">
		<label for="" class="form_label">授权码</label>
		<input type="text" class="form-control form_control" readonly="readonly" name="" id="" value="" v-model="form.authCode" placeholder="请输入授权码" />
		<i class="glyphicon icon_reload" @click="authorizationBoxShow()"></i>
		<p class="tip_sub_text hint_small_left">
			<small>(不在应用库中显示,通过搜索授权码显示)</small>
		</p>
	</section>
  </el-form>
</template>

<script>
import titleArea from './title_area'
	export default {
		data() {
			var validatePublishType = (rule, value, callback) => {
				if(this.form.publishType == 2 && this.form.publishTime == '')
				      {
				      	callback(new Error('请填写发布时间'));
				      }
				      else
				      {
				      	callback();
				      }
				};
			return {
				hid: false,
				hidsub: false,
				hidsubv: false,
				form: {
					publishType:'',
					publishTime:'',
					authType:'',
					authCode:'',
				},
				rules: {
					publishType:[
						{ required: true, message: '发布时间', trigger: 'change' },{validator:validatePublishType,  trigger: 'blur' }
					],
					authType:[
					 { required: true, message: '授权类型', trigger: 'change' }
					]
				},
      }
		},

		components: {
			titleArea
		},

		mounted: function() {
			this.$nextTick(function() {
			  this.hid = this.$parent.hid;
			  this.hidsub = this.$parent.hidsub;
			  this.hidsubv = this.$parent.hidsubv;
              this.form.publishType = parseInt(this.$parent.tCloudAppVersion.publishType);
              this.form.publishTime = this.$parent.tCloudAppVersion.publishTime;
              this.form.authType = parseInt(this.$parent.tCloudApp.authType);
              this.form.authCode = this.$parent.tCloudApp.authCode;
			})
		},

		props: {
			data: {}
		},

		methods: {
			verify() {//form表单的校验结果
				let flag;
				this.$refs['form'].validate((valid) => {
					if(valid) {
						flag = true;
					} else {
						console.log('error submit!!');
						flag = false;
						return false;
					}
				});
				if(flag)
				{
					return {
						flag: flag,
						status: 6,
						form: this.form
					};
				}
			},
			saveverify() { //form表单的校验结果
				return {
					flag: true,
					status: 6,
					form: this.form
				};
			},
			openSub: function() {
				var type = this.form.publishType;
			},
			authorizationBoxShow: function(e) {
				var temp = this;
				if(this.form.authType == 2) {
					$("#radio_authorization_form_box").show()
					this.$http.post('/zklccloud/queryAuthCode', {
						emulateJSON: true
					}).then(function(m) {
						if(m.body.resultCode == '0') {
							temp.form.authCode = m.body.content.authCode;
						} else {
							MessageBox('查询失败！', '提示', 'error', {
								confirmButtonText: '确定',
							});
						}
					})
				} 
			},
		}
	}
</script>

<style scoped>
.time_option_box {
	display: block;
	padding-top: 15px;
}
</style>


// WEBPACK FOOTER //
// publish.vue?dd81d8be